import { useCallback } from 'react';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- нужно подумать как инвалидировать кэш запросов между разными сущностями
import { invalidateCacheCategoryList } from '#entities/category';
import { showError, showSuccess } from '#shared/lib/toast';
import { updateProductVariantsStatuses } from '../api';

export function useProductVariantMenuArchiveAction(
    variantId: string | undefined,
    options: {
        confirmDelete: (args: { productCount: number }) => Promise<boolean>;
        onDeleted?: () => void;
    }
) {
    const { confirmDelete, onDeleted } = options;

    return useCallback(async () => {
        if (!variantId) {
            return;
        }

        try {
            const isConfirmed = await confirmDelete({ productCount: 1 });

            if (!isConfirmed) {
                return;
            }

            const newStatus = 'ARCHIVED';

            await updateProductVariantsStatuses({
                variant_ids: [],
                target_status: newStatus,
                query: {
                    variant_ids: [variantId],
                    statuses: ['PUBLISHED', 'HIDDEN'],
                },
            });
            invalidateCacheCategoryList();
            showSuccess('Товар перенесён в архив');
            onDeleted?.();
        } catch (e) {
            showError({ label: 'Произошла ошибка при переносе в архив, попробуйте еще раз' }, e);
        }
    }, [variantId, confirmDelete, onDeleted]);
}
